module.exports = __webpack_public_path__ + "static/media/calendar-alt.35ceb0fc.svg";